import React, { useRef } from "react";
import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { classNames } from "primereact/utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../shared/CustomButton";

import { logout } from "../../redux/slices/AuthSlice";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const ProfileDropdown = () => {
  const profileMenu = useRef();
  const op = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state?.auth);
  const { t, i18n } = useTranslation();

  let profileItems = [
    {
      command: () => { },
      template: (item, options) => {
        return (
          <button
            onClick={(e) => options.onClick(e)}
            className={classNames(
              options.className,
              "w-full p-link flex items-center text-[16px] py-2 px-3 text-primary rounded-t-md"
            )}
          >
            <Avatar
              label={user?.full_name?.charAt(0).toUpperCase()}
              className="h-[40px] text-[18px] text-black w-[40px] font-[500] mr-2"
              shape="circle"
            />
            <div className="flex min-w-0 flex-col align">
              <span className="w-32 capitalize font-semibold whitespace-normal break-words">
                {user?.full_name}
              </span>
              <span className="text-14-gray">{user?.role?.[0]?.name}</span>
            </div>
          </button>
        );
      },
    },
    {
      className: "!bg-gray-100",
      label: t("Logout"),
      icon: "pi pi-sign-out",
      command: () => handleLogout(),
    },
  ];

  const handleLogout = () => {
    // if (counterStatus == 'open') {
    //   toast.error('Please close the counter before proceeding with logout.');
    //   return;
    // }
    dispatch(logout());
  };
  return (
    <div>
      <div
        onClick={(e) => profileMenu?.current?.toggle(e)}
        className="flex cursor-pointer gap-3 items-center"
      >
        <CustomButton
          buttonType="reset"
          icon="pi pi-angle-down"
          label={user?.full_name}
          onClick={(e) => profileMenu?.current?.toggle(e)}
          className="!border-0 whitespace-nowrap"
        />
      </div>
      <Menu
        model={profileItems}
        popup
        ref={profileMenu}
        id="popup_profile_menu"
        className="border-none shadow-lg text-14-gray !bg-gray-100 custom-menu mt-4 px-0 py-0"
        pt={{
          root: { className: "!rounded-md" },
          menuitem: { className: "border-b border-gray-200 py-2" },
          label: { className: "!text-14-dark group-hover:text-primary" },
          action: { className: "py-3 px-3 bg-gray-100" },
          content: { className: "bg-transparent group !hover:rounded-md" },
          icon: { className: "text-14-dark group-hover:text-primary" },
        }}
        style={{ width: "20rem" }}
      />
    </div>
  );
};

export default ProfileDropdown;
